import React from 'react';

import { callApi } from '../../../helpers/methods';
import { getToken, isAuthenticated } from '../../../store/auth';
import { MESSAGE_ERROR, AUTH_ERROR, AUTH_HEADER, API_BASE_URL } from '../../../helpers/constants';

import { Icon } from '../../inspinia';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

export default class RemetentesList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            listaRemetentes: [],
            recarregar: false,
            alerta: withReactContent(Swal),
            loading: false,

            hoveredIndex: null
        };

        this.LoadRemetentes = this.LoadRemetentes.bind(this);
        this.onClickExcluir = this.onClickExcluir.bind(this);
        this.excluir = this.excluir.bind(this);

        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    componentDidMount() {
        this.LoadRemetentes();
    }

    LoadRemetentes() {
        let self = this;
        const url = `${API_BASE_URL}/listSender`;
        const options = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true });

        callApi(url, options, function(response) {
            self.setState({
                ...self.state,
                listaRemetentes: response,
                loading: false
            });
        });
    }

    onClickExcluir(index, remetente) {
        let id = remetente.id;
        this.state.alerta.fire({
            title: 'Realmente deseja excluir o remetente ' + remetente.nome + '?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#47A789',
            cancelButtonColor: '#ED5358',
            reverseButtons: true,
            preConfirm: () => {
                return this.excluir(index, id);
            },
            allowOutsideClick: () => !this.state.alerta.isLoading(),
            showLoaderOnConfirm: true,
            backdrop: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.state.alerta.fire({
                    title: `${result.value.title}`,
                    text: `${result.value.text}`,
                    icon: `${result.value.status}`,
                    confirmButtonColor: '#47A789'
                })
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                this.state.alerta.fire({
                    title: 'Cancelado',
                    text: 'Remetente não excluído',
                    icon: 'error',
                    confirmButtonColor: '#47A789'
                })
            }
        });
    }

    async excluir(index, id) {
        let self = this;

        if (!isAuthenticated()) {
            throw (MESSAGE_ERROR(AUTH_ERROR));
        }

        const _token = AUTH_HEADER(getToken());

        let remetenteRequest = {
            idRemetente: id
        };

        const url = `${API_BASE_URL}/sender`;
        const options = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': _token
            },
            body: JSON.stringify(remetenteRequest)
        };

        try {
            const response = await fetch(url, options);
            let json = await response.json();

            if (response.ok) {
                if (json.status === 'success') {
                    let result = self.state.listaRemetentes;
                    result.splice(index, 1);
                    self.setState({ ...self.state, listaRemetentes: result });
                }
                return json;
            }
        } catch (error) {
            return error.data;
        }
    }

    handleMouseEnter(index) {
        this.setState({ hoveredIndex: index });
    }

    handleMouseLeave() {
        this.setState({ hoveredIndex: null });
    }

    render() {
        let html = "";

        if (this.state.loading) {
            html = (
                <div className="sk-spinner sk-spinner-three-bounce">
                    <div className="sk-bounce1"></div>
                    <div className="sk-bounce2"></div>
                    <div className="sk-bounce3"></div>
                </div>
            );
        } else if (!this.state.listaRemetentes || this.state.listaRemetentes.length === 0) {
            html = (<div className="mb-2">Nenhum registro encontrado.</div>);
        } else {
            html = this.state.listaRemetentes.map((remetente, index) => {
                const isHovered = this.state.hoveredIndex === index;

                return (
                    <div className="mb-2" key={remetente.id}>
                        <a onClick={() => this.onClickExcluir(index, remetente)}>
                            <Icon name="fa-times" className="mx-1 text-muted" />
                        </a>

                        <span
                            style={{
                                cursor: 'pointer',
                                marginLeft: 8,
                                color: isHovered ? 'blue' : 'inherit',
                                textDecoration: isHovered ? 'underline' : 'none',
                                transition: 'color 0.2s'
                            }}
                            onClick={() => {
                                if (this.props.onRemetenteSelected) {
                                    this.props.onRemetenteSelected(remetente);
                                }
                            }}
                            onMouseEnter={() => this.handleMouseEnter(index)}
                            onMouseLeave={this.handleMouseLeave}
                        >
                            Nome: {remetente.nome} - E-mail: {remetente.email}
                        </span>
                    </div>
                );
            });
        }

        return (
            <div 
                className="form-group mb-6 text-muted px-4 py-2"
                style={{
                    maxHeight: "90px",
                    height: "90px",
                    overflowY: "auto",
                    border: "solid 1px #bbb",
                    borderRadius: "0px"
                }}
            >
                {html}
            </div>
        );
    }
}
